import React from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import BottomSheet from "./BottomSheet";
import FanClaimButtons from "./FanClaimButtons";
import FanJoinHead from "./FanJoinHead";
import { clearAppRole } from "../lib/appRole";
import type { FanUser } from "../lib/fanAccount";
import "./FanSignInSheet.css";
import { t } from "../i18n";

// The big sign-in sheet (locked r6 §3; one headline since 1.5.1 #15, see
// FanJoinHead). Opens from
// the header chip for brand-new fans (nothing tracked yet, so there's no
// requests sheet worth showing). Fans with any history reach sign-in via
// their profile sheet → My Profile › editor instead.
const FanSignInSheet: React.FC<{
  open: boolean;
  onClose: () => void;
  /** After it closes: the header decides where they go. */
  onSignedIn?: (fan: FanUser) => void;
}> = ({ open, onClose, onSignedIn }) => {
  const navigate = useNavigate();
  if (!open) return null;
  const leaveFanMode = () => {
    // In the app, signed-out fans have no editor — this quiet row is their
    // door out of fan mode (mis-picked DJs must never be trapped). Device
    // request history survives.
    clearAppRole();
    onClose();
    navigate("/welcome?role=1");
  };
  return (
    <BottomSheet open={open} title={t("fanRequestsPanel.makeRequestsEarnPoints")} onClose={onClose} plain>
      <FanJoinHead />
      <FanClaimButtons
        onSignedIn={(fan) => {
          onClose();
          onSignedIn?.(fan);
        }}
      />
      <div className="fansignin-foot">{t("fanSignInSheet.requestingASongNever")}</div>
      {Capacitor.isNativePlatform() && (
        <button type="button" className="fansignin-exit" onClick={leaveFanMode}>
          {t("fanSignInSheet.areYouADj")}
        </button>
      )}
    </BottomSheet>
  );
};

export default FanSignInSheet;
